<template>
	<div>
		<div class="col-sm-4 pl0">
			<select class="form-control" @change="changeLevel1" v-model="changeArea_1">
				<option v-for="lev in area_1" value="{{lev}}">{{lev}}</option>
			</select>
		</div>
		<div class="col-sm-4" v-show="area_2.length > 0">
			<select class="form-control" @change="changeLevel2" v-model="changeArea_2">
				<option v-for="lev in area_2" value="{{lev}}">{{lev}}</option>
			</select>
		</div>
		<div class="col-sm-4 pr0" v-show="area_3.length > 0">
			<select class="form-control" v-model="changeArea_3">
				<option v-for="lev in area_3" value="{{lev}}">{{lev}}</option>
	    	</select>
		</div>
	</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var isInitData = true;//标识是否初始化的数据
	/**
	* 区域的筛选
	*/
	var filterArea = function(area,succ){
		Http.area.query({
			data : {area : area},
			succ : succ
		});
	};
	/**
	* 一级区域的筛选
	* @param vm 当前ViewModel
	* @param isChange 标识是否是在select选择时调用
	*/
	var level_1 = function(vm,isChange){
		filterArea('',function(rs){
			vm.area_1 = rs;
			if(vm.area_1.length > 0){
				if(isChange){
					for(var i = 0, len = vm.area_1.length; i < len; i++) {
						if(vm.area_1[i] == "四川省") {
							vm.changeArea_1 = vm.area_1[i];
							break;
						}
					}
					// vm.changeArea_1 = vm.area_1[0];
				}
				level_2(vm.changeArea_1,vm,isChange);
			}else{
				vm.area_2 = [];
				vm.area_3 = [];
				vm.changeArea_2 = '';
				vm.changeArea_3 = '';
			}
		});
	};
	/**
	* 二级区域的筛选
	* @param lev 上级的区域名称
	* @param vm 当前ViewModel
	* @param isChange 标识是否是在select选择时调用
	*/
	var level_2 = function(lev,vm,isChange){
		filterArea(lev,function(rs){
			vm.area_2 = rs;
			if(vm.area_2.length > 0){
				if(isChange){
					vm.changeArea_2 = vm.area_2[0];
				}
				level_3(vm.changeArea_2,vm,isChange);
			}else{				
				vm.area_3 = [];
				vm.changeArea_2 = '';
				vm.changeArea_3 = '';
			}
		});
	};
	/**
	* 三级区域的筛选
	* @param lev 上级的区域名称
	* @param vm 当前ViewModel
	* @param isChange 标识是否是在select选择时调用
	*/
	var level_3 = function(lev,vm,isChange){
		filterArea(lev,function(rs){
			vm.area_3 = rs;
			if(isChange){
				if(vm.area_3.length > 0 ){
					vm.changeArea_3 = vm.area_3[0];
				}else{
					vm.changeArea_3 = '';				
				}
			}
		});
	};
	module.exports = {
		props : ['address'],//由外部传入
		data : function(){
			return {
				area_1 : [], //一级区域对应的数据
				area_2 : [], //二级区域对应的数据
				area_3 : [], //三级区域对应的数据
				changeArea_1 : '',//选中的一级区域
				changeArea_2 : '',//选中的一级区域
				changeArea_3 : '',//选中的一级区域
			}
		},
		created : function(){
			isInitData = true;
			if(this.address != undefined && this.address.length > 0){
				isInitData = false;
				this.changeArea_1 = this.address[0];
				this.changeArea_2 = this.address[1];
				this.changeArea_3 = this.address[2];
			}
		},
		ready : function(){
			console.log("isInitData:" + isInitData);
			level_1(this,isInitData);
		},
		computed : {
			fullArea : function(){
				return [this.changeArea_1 , this.changeArea_2 , this.changeArea_3];
			}
		},
		methods : {
			changeLevel1 : function(){
				level_2(this.changeArea_1,this,true);
			},
			changeLevel2 : function(){
				level_3(this.changeArea_2,this,true);
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** Address.vue?3ef2a5c8
 **/